import {GetterTree} from "vuex";
import {RootState} from "@/store/state";
import {StatisticsScreenState} from "@/modules/statistics/store/state";

export enum StatisticsGetters {
  GET_STATISTICS_ITEMS = "GET_STATISTICS_ITEMS",
  GET_IS_LOADING = "GET_IS_LOADING",
  GET_ERROR = "GET_ERROR",
}

const getters: GetterTree<StatisticsScreenState, RootState> = {
  [StatisticsGetters.GET_STATISTICS_ITEMS](state: StatisticsScreenState): any {
    return state.items;
  },

  [StatisticsGetters.GET_IS_LOADING](state: StatisticsScreenState): any {
    return state.isLoading;
  },

  [StatisticsGetters.GET_ERROR](state: StatisticsScreenState): string {
    return state.error.message;
  },
};

export default getters;
